<template>
    <div class="login-wrap">
        <div class="ms-login">
            <div class="ms-title">展业水务</div>
            <el-form :model="param" :rules="rules" ref="login" label-width="0px" class="ms-content">
                <el-form-item prop="username">
                    <el-input v-model="param.account" placeholder="请输入账号">
                        <el-button slot="prepend" icon="el-icon-lx-people"></el-button>
                    </el-input>
                </el-form-item>
                <el-form-item prop="password">
                    <el-input
                        type="password"
                        placeholder="请输入密码"
                        v-model="param.pwd"
                        @keyup.enter.native="submitForm()"
                    >
                        <el-button slot="prepend" icon="el-icon-lx-lock"></el-button>
                    </el-input>
                </el-form-item>
                <div class="login-btn">
                    <el-button type="primary" @click="submitForm()">登录</el-button>
                </div>
            </el-form>
        </div>
       <a class='ver_hor_center' href='https://beian.miit.gov.cn'>浙ICP备2024091017号</a>
    </div>
</template>

<script>

export default {
    created() {

    },
    data: function() {
        return {
            param: {
                account: '',
                pwd: '',
            },
            rules: {
                account: [{ required: true, message: '请输入用户账号', trigger: 'blur' }],
                pwd: [{ required: true, message: '请输入密码', trigger: 'blur' }],
            },
        };
    },
    methods: {
        submitForm() {
            const that = this
            console.log("phone")
            this.http.post("user/mgLogin",this.param).then(res=>{
                    if (res.code == 0){
                      this.$message.success('登录成功');
                      localStorage.setItem('userInfo', res.data);
                        localStorage.setItem('uid', res.data.id);
                        localStorage.setItem('token_info',JSON.stringify(res.data))

                      console.log("dataName"+res.data.name)
                        localStorage.setItem('userName', res.data.name);
                        that.$router.push('/indexTable');
                    }
                    },
                    err=>{
                        console.log("err"+err)
                    }
                )
            },
        },

};
</script>

<style scoped>
.content {
    width: 360px;
    height: 240px;
}
.ver_hor_center {
    position: absolute;
    top: 95%;
    left: 50%;
    margin-left: -150px;
    width: 300px;
    color: #000000;
    font-size: 20px;
    font-weight: bold;

}
.login-wrap {
    position: relative;
    width: 100%;
    height: 100%;
    background-image: url(../../assets/img/login-bg.jpg);
    background-size: 100%;
}
.ms-title {
    width: 100%;
    line-height: 50px;
    text-align: center;
    font-size: 20px;
    color: #fff;
    border-bottom: 1px solid #ddd;
}
.ms-login {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 350px;
    margin: -190px 0 0 -175px;
    border-radius: 5px;
    background: rgba(255, 255, 255, 0.3);
    overflow: hidden;
}
.ms-content {
    padding: 30px 30px;
}
.login-btn {
    text-align: center;
}
.login-btn button {
    width: 100%;
    height: 36px;
    margin-bottom: 10px;
}
.login-tips {
    font-size: 12px;
    line-height: 30px;
    color: #fff;
}
</style>